var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMmProToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#33CC66"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3136 14.5327V9.33888H29.0085V14.5327H26.7712L23.3644 17.8787V7.89061H21.178V0H20.8729V7.89061H18.6356V17.8787L15.2288 14.5327H12.9915V9.33888H12.6864V14.5327H10.5V27.9667H12.6864V35.258H12.9915V27.9667H15.2288V20.0761L18.6356 23.4221V31.912H20.8729V42H21.178V31.912H23.3644V23.4221L26.7712 20.0761V27.9667H29.0085V35.258H29.3136V27.9667H31.5V14.5327H29.3136Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmProToken);
export default __webpack_public_path__ + "static/media/MMProToken.d24a27762aca05b752f2e6fd8c875fc5.svg";
export { ForwardRef as ReactComponent };